import React from "react";
import {
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import {
  WorkflowInputValues,
  WorkflowInputValue,
} from "common/flowmaster/types/workflow";
import {Definition} from "./data_assets_create_view";

const styles = {
  inputsContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: "1.5em",
    gap: "1.5em",
  },
  inputRow: {
    display: "flex",
    alignItems: "center",
  },
  inputName: {
    width: 100,
    paddingRight: "1em",
    fontSize: "0.85rem",
    color: "#424242",
  },
  typeSelector: {
    width: 100,
    marginRight: "1em",
  },
  textField: {
    flex: 1,
  },
  helperText: {
    marginTop: "1em",
  },
} as const;

interface ConfigurationInputsProps {
  definition?: Definition;
  inputValues: WorkflowInputValues;
  onInputChange: (inputId: string, value: WorkflowInputValue) => void;
}

const ConfigurationInputs: React.FC<ConfigurationInputsProps> = ({
  definition,
  inputValues,
  onInputChange,
}) => {
  if (!definition) {
    return null;
  }

  const definitionInputs = definition.inputs?.values || [];
  if (definitionInputs.length === 0) {
    return (
      <Typography variant="body2" style={styles.helperText}>
        No inputs defined for this definition.
      </Typography>
    );
  }

  return (
    <div style={styles.inputsContainer}>
      {definitionInputs.map(input => {
        const inputId = String(input.id);
        const displayName = input.label || input.name;

        // use default value if it exists and no value set
        const displayValue =
          inputValues[inputId] ??
          ((input.has_default && input.default_value) || "");

        return (
          <div key={inputId} style={styles.inputRow}>
            <div style={styles.inputName}>{displayName}</div>

            <FormControl
              variant="outlined"
              size="small"
              style={styles.typeSelector}
            >
              <InputLabel>Type</InputLabel>
              <Select
                value="literal"
                label="Type"
                style={{textTransform: "capitalize"}}
              >
                <MenuItem value="literal">Literal</MenuItem>
              </Select>
            </FormControl>

            <TextField
              variant="outlined"
              style={styles.textField}
              value={displayValue}
              onChange={e => onInputChange(inputId, e.target.value)}
              size="small"
              label="Prompt"
              multiline
              rowsMax={4}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ConfigurationInputs;
